export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  categories: string[];
  year: number;
  rating: number;
  poster: string;
  posterLarge: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  language: string;
  releaseDate: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  viewCount: number;
}

export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-flashlight-line', count: 128 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line', count: 95 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 76 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 83 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 62 },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line', count: 110 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line', count: 45 },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line', count: 71 },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line', count: 38 },
  { slug: 'qihuan', name: '奇幻片', icon: 'ri-magic-line', count: 54 },
  { slug: 'fanzui', name: '犯罪片', icon: 'ri-police-car-line', count: 49 },
  { slug: 'juqing', name: '剧情片', icon: 'ri-film-line', count: 102 },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: '科幻片',
    categories: ['科幻片', '动作片'],
    year: 2026,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20giant%20planet%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20and%20warm%20color%20tone%2C%20movie%20poster%20style%20with%20Chinese%20typography%20space&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%20with%20astronaut%20and%20giant%20planet%20in%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20dark%20tone%2C%20movie%20banner%20style&width=800&height=450&seq=movie-hero-01&orientation=landscape',
    description: '太阳急速老化，持续膨胀。为了应对这场灭顶之灾，人类在地球表面建造了一万座行星发动机，推动地球离开太阳系，开启了长达2500年的流浪之旅。第三部中，人类面临着前所未有的挑战——地木危机后的新家园探索。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    duration: '173分钟',
    language: '汉语普通话',
    releaseDate: '2026-02-10',
    isHot: true,
    isNew: true,
    isRecommended: true,
    viewCount: 28560000,
  },
  {
    id: '2',
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    category: '奇幻片',
    categories: ['奇幻片', '动作片', '战争片'],
    year: 2025,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20mythology%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20beasts%2C%20dramatic%20epic%20style%2C%20golden%20and%20dark%20tones%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20movie%20scene%20with%20ancient%20warriors%20battle%20and%20mythical%20creatures%2C%20golden%20warm%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-02&orientation=landscape',
    description: '商王殷寿与狐妖妲己暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。第二部延续第一部剧情，西岐与朝歌的决战全面爆发，神仙妖魔悉数登场。',
    director: '乌尔善',
    actors: ['黄渤', '费翔', '李雪健', '夏雨', '陈坤'],
    region: '中国大陆',
    duration: '148分钟',
    language: '汉语普通话',
    releaseDate: '2025-07-20',
    isHot: true,
    isNew: true,
    isRecommended: true,
    viewCount: 22340000,
  },
  {
    id: '3',
    title: '消失的她',
    titleEn: 'Lost in the Stars',
    category: '悬疑片',
    categories: ['悬疑片', '犯罪片', '剧情片'],
    year: 2023,
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20Chinese%20movie%20poster%20with%20mysterious%20woman%20and%20dark%20ocean%20background%2C%20moody%20atmospheric%20lighting%2C%20film%20noir%20style%2C%20dramatic%20composition&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Dark%20suspenseful%20Chinese%20movie%20scene%20with%20mysterious%20ocean%20and%20lighthouse%20at%20night%2C%20atmospheric%20moody%20lighting%2C%20thriller%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-03&orientation=landscape',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失。当他苦寻无果之时，一个陌生女人突然出现，声称自己就是何非的妻子。随着故事展开，一个惊天秘密逐渐浮出水面。',
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    region: '中国大陆',
    duration: '121分钟',
    language: '汉语普通话',
    releaseDate: '2023-06-22',
    isHot: true,
    isNew: false,
    isRecommended: true,
    viewCount: 35890000,
  },
  {
    id: '4',
    title: '九龙城寨之围城',
    titleEn: 'Twilight of the Warriors: Walled In',
    category: '动作片',
    categories: ['动作片', '犯罪片'],
    year: 2024,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20movie%20poster%20with%20martial%20arts%20fighters%20in%20dark%20alley%2C%20neon%20lighting%2C%20gritty%20urban%20style%2C%20cinematic%20action%20poster&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Gritty%20Hong%20Kong%20action%20movie%20scene%20with%20martial%20arts%20fight%20in%20narrow%20alley%20with%20neon%20signs%2C%20dark%20moody%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-04&orientation=landscape',
    description: '八十年代，偷渡来港的青年陈洛军误闯九龙城寨，在这个三不管地带中，他结识了一群重情重义的兄弟，却也卷入了帮派之间的生死争斗，九龙城寨的秘密逐渐被揭开。',
    director: '郑保瑞',
    actors: ['古天乐', '洪金宝', '任贤齐', '林峯', '刘俊谦'],
    region: '中国香港',
    duration: '126分钟',
    language: '粤语 / 汉语普通话',
    releaseDate: '2024-05-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
    viewCount: 19870000,
  },
  {
    id: '5',
    title: '孤注一掷',
    titleEn: 'No More Bets',
    category: '犯罪片',
    categories: ['犯罪片', '剧情片'],
    year: 2023,
    rating: 7.5,
    poster: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20Chinese%20movie%20poster%20with%20casino%20chips%20and%20dark%20figures%2C%20tense%20atmosphere%2C%20red%20and%20dark%20tones%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Tense%20Chinese%20crime%20movie%20scene%20with%20underground%20gambling%20den%20and%20neon%20lights%2C%20dark%20intense%20atmosphere%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-05&orientation=landscape',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。一场关于人性与贪婪的博弈由此展开。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    region: '中国大陆',
    duration: '130分钟',
    language: '汉语普通话',
    releaseDate: '2023-08-08',
    isHot: true,
    isNew: false,
    isRecommended: false,
    viewCount: 38500000,
  },
  {
    id: '6',
    title: '长安三万里',
    titleEn: 'Chang An',
    category: '动画片',
    categories: ['动画片', '剧情片'],
    year: 2023,
    rating: 8.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20city%20and%20poet%20riding%20horse%2C%20warm%20golden%20lighting%2C%20traditional%20Chinese%20painting%20style%2C%20cinematic&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animated%20movie%20scene%20with%20ancient%20Tang%20Dynasty%20Chang%20An%20city%20landscape%2C%20warm%20golden%20sunset%20lighting%2C%20traditional%20art%20style%2C%20cinematic%20wide&width=800&height=450&seq=movie-hero-06&orientation=landscape',
    description: '安史之乱后数年，吐蕃大军入侵西南，大唐节度使高适交战不利。困守孤城之际，他向监军太监回忆起自己与李白的一生往事，展现了大唐盛世下诗人们的豪情壮志与家国情怀。',
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全', '宣晓鸣'],
    region: '中国大陆',
    duration: '168分钟',
    language: '汉语普通话',
    releaseDate: '2023-07-08',
    isHot: false,
    isNew: false,
    isRecommended: true,
    viewCount: 18200000,
  },
  {
    id: '7',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    category: '喜剧片',
    categories: ['喜剧片', '剧情片'],
    year: 2024,
    rating: 7.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20boxing%20woman%20and%20warm%20lighting%2C%20inspirational%20sports%20theme%2C%20bright%20warm%20tones%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20movie%20scene%20with%20woman%20boxing%20training%20in%20gym%2C%20warm%20motivational%20lighting%2C%20sports%20drama%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-07&orientation=landscape',
    description: '善良的乐莹在经历了一系列挫折后，决定改变自己的人生。她开始学习拳击，在汗水和泪水中重新找到了生活的意义和自信。这是一个关于自我救赎和成长的故事。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    region: '中国大陆',
    duration: '129分钟',
    language: '汉语普通话',
    releaseDate: '2024-02-10',
    isHot: false,
    isNew: false,
    isRecommended: true,
    viewCount: 34500000,
  },
  {
    id: '8',
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: '剧情片',
    categories: ['剧情片', '战争片'],
    year: 2023,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Historical%20drama%20movie%20poster%20with%20nuclear%20explosion%20and%20scientist%20silhouette%2C%20dramatic%20orange%20fire%20lighting%2C%20intense%20cinematic%20poster&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Dramatic%20historical%20movie%20scene%20with%20nuclear%20explosion%20mushroom%20cloud%20and%20desert%20landscape%2C%20intense%20orange%20lighting%2C%20epic%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-08&orientation=landscape',
    description: '讲述了美国"原子弹之父"罗伯特·奥本海默在二战期间主导研制原子弹的故事，以及战后他面对道德与良心的挣扎。本片以独特的叙事结构展现了一个天才科学家的辉煌与悲剧。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    region: '美国 / 英国',
    duration: '180分钟',
    language: '英语',
    releaseDate: '2023-07-21',
    isHot: false,
    isNew: false,
    isRecommended: true,
    viewCount: 45200000,
  },
  {
    id: '9',
    title: '年会不能停！',
    titleEn: 'Johnny Keep Walking!',
    category: '喜剧片',
    categories: ['喜剧片'],
    year: 2023,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20office%20comedy%20movie%20poster%20with%20office%20workers%20celebrating%2C%20bright%20colorful%20lighting%2C%20funny%20atmosphere%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20office%20comedy%20movie%20scene%20with%20employees%20at%20annual%20party%2C%20bright%20colorful%20celebration%20lighting%2C%20comedic%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-09&orientation=landscape',
    description: '一个工厂钳工被阴差阳错调入集团总部，从蓝领到金领的转变让他闹出了无数笑话。本片以幽默诙谐的方式讽刺了当代职场文化，反映了打工人的辛酸与梦想。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲', '王迅', '孙艺洲'],
    region: '中国大陆',
    duration: '117分钟',
    language: '汉语普通话',
    releaseDate: '2023-12-29',
    isHot: false,
    isNew: false,
    isRecommended: false,
    viewCount: 12800000,
  },
  {
    id: '10',
    title: '周处除三害',
    titleEn: 'The Pig, the Snake and the Pigeon',
    category: '犯罪片',
    categories: ['犯罪片', '动作片'],
    year: 2024,
    rating: 8.2,
    poster: 'https://readdy.ai/api/search-image?query=Taiwan%20crime%20action%20movie%20poster%20with%20fugitive%20and%20police%2C%20dark%20intense%20atmosphere%2C%20neon%20accent%20lighting%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Intense%20Taiwan%20crime%20action%20movie%20scene%20with%20fugitive%20in%20urban%20night%2C%20dark%20moody%20street%20lighting%2C%20action%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-10&orientation=landscape',
    description: '通缉犯陈桂林在逃亡多年后，发现自己身患绝症。他决定在生命最后的时光里做一件有意义的事——除掉通缉榜上排在自己前面的两个罪犯。一场黑色幽默与暴力美学交织的犯罪故事。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文', '王净'],
    region: '中国台湾',
    duration: '134分钟',
    language: '汉语普通话 / 闽南语',
    releaseDate: '2024-03-01',
    isHot: true,
    isNew: true,
    isRecommended: true,
    viewCount: 15600000,
  },
  {
    id: '11',
    title: '第二十条',
    titleEn: 'Article 20',
    category: '剧情片',
    categories: ['剧情片', '喜剧片'],
    year: 2024,
    rating: 7.7,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20movie%20poster%20with%20courtroom%20and%20lawyer%2C%20serious%20atmosphere%2C%20warm%20lighting%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Serious%20Chinese%20legal%20drama%20movie%20scene%20in%20courtroom%20with%20lawyers%20arguing%2C%20warm%20dramatic%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-11&orientation=landscape',
    description: '检察官韩明在办理一起正当防卫案件时，陷入了法律与道德的困境。面对舆论压力和个人信仰的考验，他必须在坚持正义与保护家人之间做出艰难抉择。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶', '刘耀文'],
    region: '中国大陆',
    duration: '141分钟',
    language: '汉语普通话',
    releaseDate: '2024-02-10',
    isHot: false,
    isNew: false,
    isRecommended: false,
    viewCount: 24400000,
  },
  {
    id: '12',
    title: '飞驰人生2',
    titleEn: 'Pegasus 2',
    category: '喜剧片',
    categories: ['喜剧片', '动作片'],
    year: 2024,
    rating: 7.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20and%20driver%2C%20dynamic%20action%2C%20warm%20sunset%20lighting%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Exciting%20Chinese%20racing%20movie%20scene%20with%20race%20cars%20on%20desert%20track%2C%20dramatic%20sunset%20lighting%2C%20action%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-12&orientation=landscape',
    description: '曾经的赛车冠军张驰如今沦为驾校教练，过着颓废的生活。当一支濒临解散的老牌车队向他伸出橄榄枝时，他决定重回赛场，再次挑战人生的极限。',
    director: '韩寒',
    actors: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    region: '中国大陆',
    duration: '129分钟',
    language: '汉语普通话',
    releaseDate: '2024-02-10',
    isHot: false,
    isNew: false,
    isRecommended: false,
    viewCount: 33900000,
  },
  {
    id: '13',
    title: '默杀',
    titleEn: 'A Place Called Silence',
    category: '恐怖片',
    categories: ['恐怖片', '悬疑片', '犯罪片'],
    year: 2024,
    rating: 7.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20thriller%20movie%20poster%20with%20mysterious%20school%20building%20and%20dark%20figure%2C%20eerie%20atmosphere%2C%20cold%20dark%20lighting%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-13&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Eerie%20Chinese%20horror%20movie%20scene%20with%20dark%20school%20corridor%20at%20night%2C%20mysterious%20atmosphere%2C%20cold%20moody%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-13&orientation=landscape',
    description: '在一所女子中学里，一系列诡异事件接连发生。学生们接连失踪，而学校里的每个人似乎都隐藏着不可告人的秘密。当真相逐渐浮出水面，一个令人毛骨悚然的秘密等待揭晓。',
    director: '柯汶利',
    actors: ['王传君', '张钧甯', '吴镇宇', '王圣迪'],
    region: '中国大陆',
    duration: '109分钟',
    language: '汉语普通话',
    releaseDate: '2024-07-03',
    isHot: false,
    isNew: true,
    isRecommended: false,
    viewCount: 8900000,
  },
  {
    id: '14',
    title: '熊出没·逆转时空',
    titleEn: 'Boonie Bears: Time Twist',
    category: '动画片',
    categories: ['动画片', '喜剧片'],
    year: 2024,
    rating: 7.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20family%20movie%20poster%20with%20bears%20and%20time%20travel%20theme%2C%20colorful%20bright%20style%2C%20fun%20adventure%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-14&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animated%20movie%20scene%20with%20bears%20time%20traveling%20through%20different%20eras%2C%20bright%20vibrant%20lighting%2C%20family%20adventure%20cinematic%20wide&width=800&height=450&seq=movie-hero-14&orientation=landscape',
    description: '光头强和熊大熊二意外获得穿越时空的能力，他们将在不同的时代中展开一场惊险刺激的冒险之旅。从远古到未来，欢乐与感动交织的精彩故事。',
    director: '林汇达',
    actors: ['张伟', '张秉君', '谭笑'],
    region: '中国大陆',
    duration: '99分钟',
    language: '汉语普通话',
    releaseDate: '2024-02-10',
    isHot: false,
    isNew: false,
    isRecommended: false,
    viewCount: 19800000,
  },
  {
    id: '15',
    title: '志愿军：存亡之战',
    titleEn: 'The Volunteers: To the War 2',
    category: '战争片',
    categories: ['战争片', '剧情片'],
    year: 2024,
    rating: 7.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20in%20battle%2C%20dramatic%20epic%20style%2C%20dark%20smoky%20atmosphere%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-15&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20war%20movie%20scene%20with%20soldiers%20in%20intense%20battle%2C%20dramatic%20smoky%20battlefield%20lighting%2C%20historical%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-15&orientation=landscape',
    description: '1949年建国初期，新中国面临内忧外患。朝鲜战争爆发，中国人民志愿军跨过鸭绿江，在极其艰苦的条件下与装备精良的敌人展开殊死搏斗，用血肉之躯捍卫了国家尊严。',
    director: '陈凯歌',
    actors: ['朱一龙', '辛柏青', '张子枫', '朱亚文', '陈飞宇'],
    region: '中国大陆',
    duration: '144分钟',
    language: '汉语普通话',
    releaseDate: '2024-09-30',
    isHot: true,
    isNew: true,
    isRecommended: false,
    viewCount: 12000000,
  },
  {
    id: '16',
    title: '满江红',
    titleEn: 'Full River Red',
    category: '悬疑片',
    categories: ['悬疑片', '喜剧片', '剧情片'],
    year: 2023,
    rating: 7.4,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20movie%20poster%20with%20ancient%20Chinese%20courtyard%20and%20soldiers%2C%20dark%20red%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-16&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Mysterious%20Chinese%20historical%20movie%20scene%20in%20ancient%20courtyard%20at%20night%2C%20red%20lantern%20lighting%2C%20suspenseful%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-16&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均被卷入这起阴谋，开始了一段惊心动魄的调查。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音', '岳云鹏'],
    region: '中国大陆',
    duration: '159分钟',
    language: '汉语普通话',
    releaseDate: '2023-01-22',
    isHot: false,
    isNew: false,
    isRecommended: false,
    viewCount: 45000000,
  },
  {
    id: '17',
    title: '你想活出怎样的人生',
    titleEn: 'The Boy and the Heron',
    category: '动画片',
    categories: ['动画片', '奇幻片'],
    year: 2024,
    rating: 7.8,
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20animated%20fantasy%20movie%20poster%20with%20boy%20and%20mysterious%20heron%2C%20dreamy%20atmosphere%2C%20soft%20warm%20lighting%2C%20studio%20ghibli%20style&width=400&height=560&seq=movie-poster-17&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Dreamy%20Japanese%20animated%20movie%20scene%20with%20boy%20in%20fantasy%20world%20and%20mysterious%20heron%2C%20soft%20warm%20magical%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-17&orientation=landscape',
    description: '少年牧真人在母亲去世后，随父亲搬到乡下，遇到了一只会说话的苍鹭。在苍鹭的引导下，他进入了一个神秘的塔楼，开始了一段关于生命、死亡与成长的奇幻旅程。',
    director: '宫崎骏',
    actors: ['山时聪真', '菅田将晖', '柴崎幸', '爱缪'],
    region: '日本',
    duration: '124分钟',
    language: '日语',
    releaseDate: '2024-04-03',
    isHot: false,
    isNew: false,
    isRecommended: true,
    viewCount: 7800000,
  },
  {
    id: '18',
    title: '抓娃娃',
    titleEn: 'Successor',
    category: '喜剧片',
    categories: ['喜剧片', '剧情片'],
    year: 2024,
    rating: 7.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20father%20and%20son%20and%20claw%20machine%2C%20warm%20family%20atmosphere%2C%20bright%20colorful%20lighting%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-18&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Warm%20Chinese%20comedy%20movie%20scene%20with%20father%20and%20son%20at%20arcade%2C%20bright%20colorful%20lighting%2C%20family%20fun%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-18&orientation=landscape',
    description: '沈腾饰演的马成钢是一个普通的工厂工人，他最大的爱好就是陪儿子抓娃娃。当工厂面临倒闭危机时，他凭借抓娃娃练就的精准手感，意外拯救了整个工厂，也实现了父子之间的情感和解。',
    director: '闫非 / 彭大魔',
    actors: ['沈腾', '马丽', '史彭元', '萨日娜'],
    region: '中国大陆',
    duration: '133分钟',
    language: '汉语普通话',
    releaseDate: '2024-07-16',
    isHot: true,
    isNew: true,
    isRecommended: false,
    viewCount: 31200000,
  },
  {
    id: '19',
    title: '沙丘2',
    titleEn: 'Dune: Part Two',
    category: '科幻片',
    categories: ['科幻片', '动作片', '奇幻片'],
    year: 2024,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20desert%20planet%20and%20giant%20sandworm%2C%20dramatic%20golden%20lighting%2C%20cinematic%20epic%20poster&width=400&height=560&seq=movie-poster-19&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20desert%20planet%20landscape%20and%20giant%20sandworm%2C%20dramatic%20golden%20sunset%20lighting%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-19&orientation=landscape',
    description: '保罗·厄崔迪与契妮和弗雷曼人联手，踏上对致其家毁人亡的阴谋者的复仇之路。当面对一生挚爱和已知宇宙命运之间的抉择时，他必须努力阻止只有他能预见的可怕未来。',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚', '丽贝卡·弗格森', '奥斯汀·巴特勒'],
    region: '美国 / 加拿大',
    duration: '166分钟',
    language: '英语',
    releaseDate: '2024-03-08',
    isHot: false,
    isNew: false,
    isRecommended: true,
    viewCount: 28500000,
  },
  {
    id: '20',
    title: '毒液：最后一舞',
    titleEn: 'Venom: The Last Dance',
    category: '动作片',
    categories: ['动作片', '科幻片', '喜剧片'],
    year: 2024,
    rating: 6.5,
    poster: 'https://readdy.ai/api/search-image?query=Superhero%20movie%20poster%20with%20dark%20symbiote%20creature%2C%20dramatic%20dark%20atmosphere%2C%20edgy%20style%2C%20cinematic%20poster&width=400&height=560&seq=movie-poster-20&orientation=portrait',
    posterLarge: 'https://readdy.ai/api/search-image?query=Dark%20superhero%20movie%20scene%20with%20symbiote%20creature%20in%20urban%20night%2C%20dramatic%20dark%20lighting%2C%20action%20cinematic%20wide%20shot&width=800&height=450&seq=movie-hero-20&orientation=landscape',
    description: '埃迪和毒液正在逃亡，被两个世界的追兵围捕。在走投无路的情况下，这对搭档被迫做出毁灭性决定，这将为毒液和埃迪的最后一舞画上句号。',
    director: '凯莉·马塞尔',
    actors: ['汤姆·哈迪', '切瓦特·埃加福', '朱诺·坦普尔', '瑞斯·伊凡斯'],
    region: '美国',
    duration: '109分钟',
    language: '英语',
    releaseDate: '2024-10-23',
    isHot: true,
    isNew: true,
    isRecommended: false,
    viewCount: 16700000,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '王先生',
    location: '北京',
    rating: 5,
    content: '8090影院真是太棒了！片源丰富，更新速度超快，画质清晰流畅。我已经推荐给身边所有朋友了，大家都很喜欢。',
    date: '2026-07-15',
  },
  {
    id: 2,
    name: '李女士',
    location: '上海',
    rating: 5,
    content: '无广告的观影体验太舒服了，不卡顿不缓冲，下班回家看一部电影成了我每天的放松方式。片库真的很全。',
    date: '2026-07-20',
  },
  {
    id: 3,
    name: '张同学',
    location: '广州',
    rating: 5,
    content: '作为电影爱好者，8090影院是我用过最好的免费电影网站。分类清晰，找片方便，还有详细的电影介绍和评分。',
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '刘先生',
    location: '深圳',
    rating: 4,
    content: '用了半年多了，一直很稳定。高清片源多，加载速度快，家里的电视连上也看得很清楚。希望越做越好！',
    date: '2026-07-25',
  },
  {
    id: 5,
    name: '陈女士',
    location: '成都',
    rating: 5,
    content: '孩子特别喜欢看动画片专区，周末全家一起看电影成了我们的固定节目。感谢8090影院给我们带来的快乐时光。',
    date: '2026-07-28',
  },
  {
    id: 6,
    name: '赵先生',
    location: '杭州',
    rating: 5,
    content: '国内外大片一应俱全，新片上架速度也很快。最重要的是完全免费还没有广告，良心网站，必须支持！',
    date: '2026-07-30',
  },
];

export const faqs = [
  {
    question: '8090影院需要注册会员吗？',
    answer: '不需要。8090影院完全免费开放，无需注册即可观看所有电影。我们致力于为用户提供最便捷的观影体验。',
  },
  {
    question: '8090影院的电影画质如何？',
    answer: '我们提供高清画质的电影资源，大部分影片支持1080P高清播放。根据您的网络环境自动匹配最佳清晰度，确保流畅观影。',
  },
  {
    question: '为什么8090影院没有广告？',
    answer: '8090影院坚持纯净观影理念，通过优化运营成本和技术方案，实现零广告干扰的观影体验，让用户沉浸在电影世界中。',
  },
  {
    question: '电影多久更新一次？',
    answer: '我们每天都会更新片库，国内外新片上映后会在第一时间上线。热门大片通常在院线下映后1-2周内即可观看。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '8090影院支持电脑、平板、手机等多种设备观看，页面采用响应式设计，自动适配不同屏幕尺寸，随时随地享受电影。',
  },
  {
    question: '如何搜索想看的电影？',
    answer: '您可以使用网站顶部的搜索功能，输入电影名称即可快速找到。也可以通过分类页面按类型、地区、年份等条件筛选电影。',
  },
];